import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SITE_CONFIG } from '@/lib/constants';
import { EngravedBackground } from '@/components/common/EngravedBackground';

/**
 * Hero section for the home page
 */
export function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-transparent to-transparent" />

      {/* 3D Engraved Logo Background */}
      <EngravedBackground
        size="xl"
        position="center"
        opacity={0.04}
        className="top-1/3"
      />

      <div className="container-custom relative z-10">
        <div className="flex min-h-[70vh] flex-col items-center justify-center py-20 text-center">
          {/* Category label */}
          <span className="category-label animate-fade-in opacity-0">
            Professional Services
          </span>

          {/* Main heading */}
          <h1 className="animate-fade-in-up opacity-0 max-w-4xl text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl">
            Quality Craftsmanship,{' '}
            <span className="gradient-text">Personal Touch</span>
          </h1>

          {/* Subtitle */}
          <p className="animate-fade-in-up opacity-0 stagger-1 mt-6 max-w-2xl text-lg text-muted-foreground sm:text-xl">
            {SITE_CONFIG.description}
          </p>

          {/* CTA buttons */}
          <div className="animate-fade-in-up opacity-0 stagger-2 mt-10 flex flex-col gap-4 sm:flex-row">
            <Button asChild size="lg" className="gap-2">
              <Link to="/services">
                Explore Services
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg">
              <Link to="/gallery">View Gallery</Link>
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="animate-fade-in opacity-0 stagger-3 mt-16 flex flex-wrap items-center justify-center gap-8 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <div className="h-2 w-2 rounded-full bg-primary" />
              <span>Tasmania Based</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-2 w-2 rounded-full bg-primary" />
              <span>Quality Guaranteed</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-2 w-2 rounded-full bg-primary" />
              <span>Personal Service</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
